export { default } from './IconLabel';
